var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 8V3.83267C13.3327 3.78004 13.3224 3.72793 13.3022 3.67931C13.2821 3.63069 13.2526 3.58652 13.2153 3.54933L11.1167 1.45067C11.0417 1.37563 10.9401 1.33343 10.834 1.33333H3.06602C2.95993 1.33333 2.85819 1.37548 2.78317 1.45049C2.70816 1.52551 2.66602 1.62725 2.66602 1.73333V14.2667C2.66602 14.3728 2.70816 14.4745 2.78317 14.5495C2.85819 14.6245 2.95993 14.6667 3.06602 14.6667H8.66602M5.33268 6.66667H10.666M5.33268 4H7.99935M5.33268 9.33333H7.33268",
    stroke: "white",
    strokeOpacity: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 1.33333V3.6C10.666 3.70609 10.7082 3.80783 10.7832 3.88284C10.8582 3.95786 10.9599 4 11.066 4H13.3327M13.3273 10.0833L15.0313 10.516C15.2087 10.5613 15.3333 10.7227 15.328 10.9053C15.2133 14.744 12.9993 15.3333 12.9993 15.3333C12.9993 15.3333 10.7853 14.744 10.6707 10.9053C10.6689 10.8165 10.6972 10.7296 10.7511 10.6589C10.8049 10.5882 10.8812 10.5378 10.9673 10.516L12.6713 10.0833C12.8867 10.0287 13.112 10.0287 13.3273 10.0833Z",
    stroke: "white",
    strokeOpacity: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIconDark);
export default __webpack_public_path__ + "static/media/aboutIconDark.1a5e07aebde540d2f58b4d875b05d79a.svg";
export { ForwardRef as ReactComponent };